module.exports = __webpack_public_path__ + "img/generalmobile-gm5-plus.0e375dcc.png";